/*
 * BOM CRO — 07-09-2026. Onderbouwd met Microsoft Clarity (1-7 sept, 801 sessies).
 *
 *   1. Sticky koopbalk op mobiel   — ATC stond op 1310px bij een 812px viewport,
 *                                    46,2% van de PDP-views haalde die diepte nooit.
 *   2. Productfoto klikbaar        — foto toonde cursor-zoom-in maar had geen
 *                                    klikbare ouder: grootste dead-click-cluster.
 *   3. Cookiebalk compacter        — 255px = 31% van het mobiele scherm, precies
 *                                    over titel en prijs. Consentmo rendert in een
 *                                    OPEN shadow root, dus de stijl moet daarbinnen.
 *
 * Alles is defensief: vindt een selector niets, dan gebeurt er niets.
 * Terugdraaien: dit bestand, assets/bom-cro.css en de twee regels onderaan
 * layout/theme.liquid weghalen.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 768px)';
  var SCROLL_TRIGGER = 150; // px voordat de balk mag verschijnen

  /* ================================================================
   * 1. Productfoto klikbaar naar de zoom (PhotoSwipe)
   * ============================================================== */
  function enableGalleryZoom() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var media = target.closest('.product-gallery__media');
        if (!media) return;

        // Laat echte knoppen en links met rust (thumbnails, pijlen).
        if (target.closest('button, a, [role="button"], input, label')) return;

        var gallery = media.closest('.product-gallery');
        var zoom = gallery && gallery.querySelector('.product-gallery__zoom-button');
        if (!zoom) return;

        event.preventDefault();
        zoom.click();
      },
      false
    );
  }

  /* ================================================================
   * 2. Sticky koopbalk op mobiel
   * ============================================================== */
  function stickyBuyBar() {
    if (!document.body.classList.contains('template-product')) return;
    if (!window.matchMedia || !window.matchMedia(MOBILE).matches) return;
    if (document.querySelector('.bom-buybar')) return;

    var form = document.querySelector('form.shopify-product-form');
    if (!form) return;

    function currentAtc() {
      // Vers ophalen: Prestige vervangt het koopblok bij een variantwissel.
      var f = document.querySelector('form.shopify-product-form');
      if (!f) return null;
      return f.querySelector('buy-buttons button[type="submit"]') ||
             f.querySelector('button[type="submit"]');
    }

    var atc = currentAtc();
    if (!atc) return;

    var titleEl = document.querySelector('h1.product-title') || document.querySelector('h1');
    var priceSource = document.querySelector('.ni-price-row') ||
                      document.querySelector('.product-info__block-item .price-list') ||
                      document.querySelector('.price-list');

    var bar = document.createElement('div');
    bar.className = 'bom-buybar';
    bar.setAttribute('aria-hidden', 'true');

    var info = document.createElement('div');
    info.className = 'bom-buybar__info';

    var title = document.createElement('span');
    title.className = 'bom-buybar__title';
    title.textContent = titleEl ? titleEl.textContent.trim() : '';

    var price = document.createElement('span');
    price.className = 'bom-buybar__price';

    info.appendChild(title);
    info.appendChild(price);

    var button = document.createElement('button');
    button.type = 'button';
    // Zelfde klasse als de echte knop, zodat hij exact het thema volgt.
    button.className = 'button bom-buybar__btn';
    button.textContent = (atc.textContent || 'Ajouter au panier').trim();

    button.addEventListener('click', function () {
      var live = currentAtc();
      if (live && !live.disabled) live.click();
    });

    bar.appendChild(info);
    bar.appendChild(button);
    document.body.appendChild(bar);

    /* --- prijs spiegelen (ook na een variantwissel) ---
     * Niet de prijsregel klonen: die draagt h4/h5-klassen (balk werd 106px),
     * sr-only labels ("Prix de vente") en een verborgen unit-price die als
     * "(/)" meelifte. We lezen alleen de twee bedragen uit. */
    var lastPriceKey = null;
    function readPrice() {
      var row = document.querySelector('.ni-price-row') || priceSource;
      if (!row) return null;

      function textOf(node) {
        if (!node || node.hasAttribute('hidden')) return '';
        var clone = node.cloneNode(true);
        Array.prototype.slice.call(clone.querySelectorAll('.sr-only')).forEach(function (n) { n.remove(); });
        return (clone.textContent || '').replace(/\s+/g, ' ').trim();
      }

      return {
        sale: textOf(row.querySelector('sale-price')) || textOf(row.querySelector('.price')),
        compare: textOf(row.querySelector('compare-at-price'))
      };
    }

    function syncPrice() {
      var p = readPrice();
      if (!p || !p.sale) return;

      var key = p.sale + '|' + p.compare;
      if (key === lastPriceKey) return;
      lastPriceKey = key;

      price.textContent = '';
      var now = document.createElement('span');
      now.textContent = p.sale;
      price.appendChild(now);

      if (p.compare && p.compare !== p.sale) {
        var was = document.createElement('s');
        was.textContent = p.compare;
        price.appendChild(was);
      }
    }

    /* --- knopstatus spiegelen (uitverkocht) --- */
    function syncState() {
      var live = currentAtc();
      if (!live) return;
      if (live.disabled) {
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('disabled');
      }
      var label = (live.textContent || '').trim();
      if (label && label !== button.textContent) button.textContent = label;
    }

    /* --- zichtbaarheid --- */
    var ticking = false;
    function update() {
      ticking = false;
      var live = currentAtc();
      if (!live) return;

      var rect = live.getBoundingClientRect();
      var atcInView = rect.top < window.innerHeight && rect.bottom > 0;
      var scrolledEnough = window.scrollY > SCROLL_TRIGGER;
      var show = scrolledEnough && !atcInView;

      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');

      if (show) {
        syncPrice();
        syncState();
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      // rAF vuurt niet in een verborgen tab; dan direct uitvoeren.
      if (typeof window.requestAnimationFrame === 'function' && !document.hidden) {
        window.requestAnimationFrame(update);
      } else {
        update();
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Variantwissels vervangen het koopblok; dan opnieuw spiegelen.
    var mo = new MutationObserver(function () { syncPrice(); syncState(); });
    mo.observe(form, { childList: true, subtree: true, attributes: true });

    syncPrice();
    syncState();
    update();
  }

  /* ================================================================
   * 3. Cookiebalk compacter (Consentmo, OPEN shadow root)
   *
   * Alleen semantische klassen (.csm-*, .cc-*), nooit de gehashte —
   * die veranderen bij elke release van de app. Er wordt niets verborgen
   * of verwijderd: beide knoppen blijven staan, de balk wordt alleen
   * strakker gezet zodat hij niet over prijs en titel valt.
   * ============================================================== */
  function compactCookieBar() {
    var CSS = [
      '@media screen and (max-width: 768px){',
      '  .csm-cmp-bar .csm-cmp-body{padding:12px 14px !important;}',
      '  .csm-cmp-bar .csm-banner-text-wrapper{font-size:15px !important;line-height:1.35 !important;margin-bottom:8px !important;}',
      '  .csm-cmp-bar .cc-compliance{display:flex !important;flex-direction:row !important;gap:8px !important;}',
      '  .csm-cmp-bar .cc-compliance .cc-btn{flex:1 1 0 !important;min-height:42px !important;margin:0 !important;padding:10px 12px !important;font-size:15px !important;}',
      '}'
    ].join('');

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      var host = document.querySelector('csm-cookie-consent');
      var root = host && host.shadowRoot;

      if (root) {
        clearInterval(timer);
        if (root.getElementById && root.getElementById('bom-cmp-compact')) return;
        var style = document.createElement('style');
        style.id = 'bom-cmp-compact';
        style.textContent = CSS;
        root.appendChild(style);
        return;
      }

      if (attempts > 40) clearInterval(timer); // ~10s, daarna opgeven
    }, 250);
  }

  /* ================================================================ */
  function init() {
    enableGalleryZoom();
    stickyBuyBar();
    compactCookieBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
